<template>
  <div class="menu-main">
    <p class="menu-main__title">{{ $t("menu.support") }}</p>

    <div class="menu-main__list">
      <a :href="privacyPolicy" target="_blank" class="menu-main__elem">
        <IconBase icon-name="IconPrivacy" class="menu__policy">
          <IconPrivacy />
        </IconBase>
        <span>{{ $t("menu.privacy-policy") }}</span>
      </a>

      <a
        href="http://saudivexpo.com/product/#about-us"
        target="_blank"
        class="menu-main__elem"
      >
        <IconBase iconName="IconAbout">
          <IconAbout />
        </IconBase>
        <span>{{ $t("menu.about-vexpo") }}</span>
      </a>

      <router-link :to="$i18nRoute({ name: 'exit' })" class="menu-main__elem">
        <IconBase iconName="IconLogOut">
          <IconLogOut />
        </IconBase>
        <span>{{ $t("menu.log-out") }}</span>
      </router-link>
    </div>

    <div class="menu-main__contacts">
      <div class="text-gold">{{ $t("menu.get-in-touch") }}</div>
      <a href="mailto:info@saudivexpo.com" class="link">info@saudivexpo.com</a>
      <a href="tel:0096616972133" class="link link__phone">00 966 1697 2133</a>
      <a href="tel:00966548726960" class="link link__phone">00 966 5487 26960</a>
    </div>
  </div>
</template>

<script>
import IconBase from "@/components/Global/DynamicIcons/IconBase";
import IconPrivacy from "@/components/Global/DynamicIcons/icons/privacy";
import IconAbout from "@/components/Global/DynamicIcons/icons/IconAbout";
import IconLogOut from "@/components/Global/DynamicIcons/icons/logout";

export default {
  name: "Support",

  components: {
    IconBase,
    IconPrivacy,
    IconAbout,
    IconLogOut,
  },
  created() {
    this.setPrivacyPolicy(this.$root.$i18n.locale || "en");
  },
  watch: {
    "$i18n.locale": async function (newLocale, oldLocale) {
      if (newLocale === oldLocale) {
        return;
      }
      this.setPrivacyPolicy(newLocale);
    },
  },
  data() {
    return {
      privacyPolicy: "",
      privacyPolicyList: {
        en: "https://saudivexpo.com/privacy-policy/",
        ar: "https://saudivexpo.com/ar/vexpo-privacy-policy/",
      },
    };
  },
  methods: {
    setPrivacyPolicy(locale) {
      this.privacyPolicy = this.privacyPolicyList[locale];
    },
  },
};
</script>


<style lang="scss" scoped>
  .menu {
    &__policy {
      margin-top: -18px;
      width: 32px;
    }

    &__policy-text {
      font-size: 14px;
    }
  }
</style>
